<template>
  <div class="powerDevice" style="height: 100%;color: #FAFAFA;">
    <label style="padding: 20px 0 10px 30px;color: #01effd;" v-if="label">
      <b-icon icon="circle" style="margin-right: 5px;"></b-icon>
      动力设备</label>
    <!--ups-->
    <el-row v-if="upsDeviceList.length>0" :style="{height: upsHeight}">
      <!--      <el-carousel :arrow="upsData.deviceInfoList.length > 1 ? 'always' : 'never'" :interval="50000"-->
      <!--                   indicator-position="none" v-else>-->
      <!--        <el-carousel-item :key="deviceInfos.id" v-for="deviceInfos in upsData.deviceInfoList">-->

      <el-carousel :interval="10000" indicator-position="none" :autoplay="true" style="height: 80%;z-index: 0"
                   @change="getUpsData">
        <el-carousel-item :key="item.id" v-for="item in upsDeviceList">

          <el-row class="text-center">
            <el-row><label :class="label ?'pointer' : ''"
               @touchstart="skipOverview(item)" @click="skipOverview(item)" style="line-height: 3vh;"> {{
                item.spaceName
              }} - {{ item.name }}</label>
            </el-row>


            <span v-if="upsData !=null">
                <!--供电模式-->
                <el-row v-if="upsData.mode">
                  <el-col :lg="7" :md="7" :sm="7" :xl="6" :xs="7" class="text-right text-blueGrey">运行模式：</el-col>
                  <el-col :lg="10" :md="10" :sm="15" :xl="10" :xs="15" class="text-left"
                          style="margin-left: 10px;color: rgba(1, 239, 253, 1)">{{ upsData.mode }}</el-col>
                </el-row>
              <!--负载功率-->
                <el-row style="margin-top: 1vh;" v-if="upsData.power">
                  <el-col :lg="7" :md="7" :sm="7" :xl="6" :xs="7" class="text-right text-blueGrey">负载功率：</el-col>
                  <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15" class="text-left" style="margin-left: 10px;">
                    {{ (upsData.power).toFixed(2) }}kW
                  </el-col>
                </el-row>
              <!--电池电压-->
                <el-row style="margin-top: 1vh;" v-if="upsData.voltage && !upsData.capacity">
                  <el-col :lg="7" :md="7" :sm="7" :xl="6" :xs="7" class="text-right text-blueGrey">电池电压：</el-col>
                  <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15" class="text-left" style="margin-left: 10px;">
                    {{ upsData.voltage }}
                  </el-col>
                </el-row>
              <!--电池容量-->
                <el-row style="margin-top: 1vh;" v-if="upsData.capacity">
                  <el-col :lg="7" :md="7" :sm="7" :xl="6" :xs="7" class="text-right text-blueGrey"
                          style="line-height: 30px;">电池容量：</el-col>
                  <el-col :lg="11" :md="11" :sm="11" :xl="13" :xs="11" class="text-left" style="margin-left: 10px;">
                    <battery-bar-chart :data="data" ref="batteryBarChart" style="height: 30px"></battery-bar-chart>
                  </el-col>
                  <el-col :lg="2" :md="2" :sm="2" :xl="2" :xs="2"
                          style="font-size: 0.9rem;line-height: 30px;">{{ upsData.capacity }}</el-col>
                </el-row>
              <!--ABC输入电压-->
               <span v-if="!upsData.mode && !upsData.power">
                  <el-row :key="item.id" style="margin-top: 1vh;"
                          v-for="item in upsData.deviceInfoList[0].deviceMeasuringPointHistoryList">
                    <el-col :lg="8" :md="9" :sm="8" :xl="7" :xs="7" class="text-right text-blueGrey">{{
                        item.pointName
                      }}：</el-col>
                    <el-col :lg="14" :md="14" :sm="14" :xl="14" :xs="15" class="text-left" style="margin-left: 10px;">
                      {{ item.pointValueName }}
                    </el-col>
                  </el-row>
                </span>
            </span>
            <div v-else>
              <no-data></no-data>
            </div>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <div v-else style="height: 50%;padding-top: 5%">
      <no-data></no-data>
    </div>


    <!--电表-->
    <el-row v-if="demDeviceList.length>0" :style="{height: meterHeight}">

      <!--      <el-carousel :arrow="meterData.deviceInfoList.length > 1 ? 'always' : 'never'" :interval="50000"-->
      <!--                   indicator-position="none" v-else>-->
      <!--        <el-carousel-item :key="deviceInfos.id" v-for="deviceInfos in meterData.deviceInfoList">-->

      <el-carousel :interval="10000" indicator-position="none" :autoplay="true" style="height: 80%;z-index: 0"
                   @change="getDemData">
        <el-carousel-item :key="item.id" v-for="item in demDeviceList">
          <el-row>
            <el-row class="text-center">
              <label :class="label ?'pointer' : ''"
                  @touchstart="skipOverview(item)"   @click="skipOverview(item)"
                     style="line-height: 3vh;">{{ item.spaceName }} -
                {{ item.name }}</label>
            </el-row>

            <span
              v-if="meterData != null && meterData.deviceInfoList[0] != null && meterData.deviceInfoList[0].deviceMeasuringPointHistoryList.length> 0">
                  <el-row style="margin-top: 10px;">
                    <span :key="history.id" v-for="history in meterData.deviceInfoList[0].deviceMeasuringPointHistoryList">
                      <el-col :span="7" style="margin-left: 5%" v-if="history.pointCode === 'ss'">
                        <div style="width: 40%;display: inline-block;text-align: right">
                          <img src="../../assets/images/index/activePower.png" alt="" style="width: 100%;">
                        </div>
                        <div class="point" style="text-align:center;float: right;width: 60%;">
                          <div class="font-weight-bold" style="color: #01EFFD;">{{ history.pointValueName }}</div>
                          <div class="text-blueGrey">{{ history.pointName }}</div>
                        </div>
                      </el-col>
                      <el-col :span="7" v-if="history.pointCode === 'sq'">
                        <div style="width: 40%;display: inline-block;text-align: right">
                          <img src="../../assets/images/index/reactivePower.png" alt="" style="width: 100%;">
                        </div>
                        <div class="point" style="text-align:center;float: right;width: 60%;">
                          <div class="font-weight-bold" style="color: #01EFFD;">{{ history.pointValueName }}</div>
                          <div class="text-blueGrey">{{ history.pointName }}</div>
                        </div>
                      </el-col>
                      <el-col :span="7" v-if="history.pointCode === 'sp'">
                    <div style="width: 40%;display: inline-block;text-align: right">
                      <img src="../../assets/images/index/power2.png" alt="" style="width: 100%;">
                    </div>
                    <div class="point" style="text-align:center;float: right;width: 60%;">
                      <div class="font-weight-bold" style="color: #01EFFD;">{{ history.pointValueName }}</div>
                      <div class="text-blueGrey">{{ history.pointName }}</div>
                    </div>
                  </el-col>
                    </span>
                </el-row>
                </span>
            <div v-else>
              <no-data></no-data>
            </div>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <div v-else style="height: 50%;padding-top: 5%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import BatteryBarChart from "@/components/echarts/BatteryBarChart";
import {getHistoryBySpacePoint} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";
import {getDeviceByTypeList} from "@/network/device-info";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "PowerDevice",
  mixins: [platenLayoutEdit],
  components: {BatteryBarChart, NoData},
  props: {
    label: {
      type: Boolean,
      default: true
    },
    upsHeight: {
      default: '18vh',
    },
    meterHeight: {
      default: '14vh',
    },
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId: {
      handler() {
        this.upsData = null;
        this.meterData = null;
        this.getData();
        this.getDeviceList();
      }
    }
  },
  data() {
    return {
      data: [],
      typeList: ["PM_UPS", "PM_DEM"],
      pointCodes: ["mode", "ap", "bp", "cp", "capacity", "batteryvoltage", "p", "q", "sp", "aiv", "biv", "civ"],
      upsData: null,
      meterData: null,
      upsDeviceList: [],
      demDeviceList: []
    }
  },
  mounted() {
    this.getDeviceList();
  },
  methods: {
    getDeviceList() {
      this.upsDeviceList = []
      this.demDeviceList = []
      getDeviceByTypeList(this.typeList,this.spaceId).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.typeEngName === 'PM_UPS') {
              this.upsDeviceList.push(item)
            }
            if (item.typeEngName === 'PM_DEM') {
              this.demDeviceList.push(item)
            }
          })
          if (this.upsDeviceList.length > 0) {
            this.getUpsData(0)
          }
          if (this.demDeviceList.length > 0) {
            this.getDemData(0)
          }
        }
      })
    },
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.typeEngName === 'PM_UPS') {
              let loadPower = 0;
              item.deviceInfoList.forEach(device => {
                if (device.deviceMeasuringPointHistoryList != null && device.deviceMeasuringPointHistoryList.length > 0) {
                  this.data = []
                  device.deviceMeasuringPointHistoryList.forEach(history => {
                    if (history.pointCode === 'ap' || history.pointCode === 'bp' || history.pointCode === 'cp') {
                      loadPower = loadPower + history.pointValue;
                    }
                    if (history.pointCode === 'mode') {
                      item.mode = history.pointValueName
                    }
                    if (history.pointCode === 'batteryvoltage') {
                      item.voltage = history.pointValueName
                    }
                    if (history.pointCode === 'capacity') {
                      item.capacity = history.pointValueName
                      this.data.push(history.pointValue)
                    }
                  })
                  item.power = loadPower;
                }
              })
              this.upsData = item
            }

            if (item.typeEngName === 'PM_DEM') {
              this.meterData = item;
            }
          })
        }
      })
    },
    getUpsData(active) {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        deviceId: this.upsDeviceList[active].id,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            let loadPower = 0;
            item.deviceInfoList.forEach(device => {
              if (device.deviceMeasuringPointHistoryList != null && device.deviceMeasuringPointHistoryList.length > 0) {
                this.data = []
                device.deviceMeasuringPointHistoryList.forEach(history => {
                  if (history.pointCode === 'ap' || history.pointCode === 'bp' || history.pointCode === 'cp') {
                    loadPower = loadPower + history.pointValue;
                  }
                  if (history.pointCode === 'mode') {
                    item.mode = history.pointValueName
                  }
                  if (history.pointCode === 'batteryvoltage') {
                    item.voltage = history.pointValueName
                  }
                  if (history.pointCode === 'capacity') {
                    item.capacity = history.pointValueName
                    this.data.push(history.pointValue)
                  }
                })
                item.power = loadPower;
              }
            })
            this.upsData = item
          })
        }
      })
    },
    getDemData(active) {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        deviceId: this.demDeviceList[active].id,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            this.meterData = item;
          })
        }
      })
    },
    skipOverview(deviceInfo) {
      if (this.isPlatenLayoutEditing) return
      this.$emit('skipOverview', deviceInfo, 'power_category_tag')
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
}

.powerDevice .el-progress >>> .el-progress-bar__outer {
  background-color: rgba(48, 141, 233, .3);
}

.powerDevice .el-progress >>> .el-progress-bar__inner {
  background: linear-gradient(to right, rgba(224, 201, 85, 1), rgba(208, 103, 102, 1));
}

.powerDevice .el-progress >>> .el-progress__text {
  margin-left: 20px;
  color: #FAFAFA;
}
</style>
